import { ColorVariables } from "..\\..\\..\\..\\src\\components\\color-variables";
import { ShapeVariables } from "..\\..\\..\\..\\src\\components\\shape-variables";
import { TypographyVariables } from "..\\..\\..\\..\\src\\components\\typography-variables";
import React from 'react';
export default {
  ColorVariables,
  ShapeVariables,
  TypographyVariables,
  React
};